/**
 * @flow
 * @relayHash 6894a7d6e06f52664777a624ccbd6bc9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Http3xxRedirectsTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type Http3xxRedirectsTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  codeFilters?: ?$ReadOnlyArray<?number>,
  typeFilters?: ?$ReadOnlyArray<?string>,
  sourceUrl?: ?TextFilters,
  redirectUrl?: ?TextFilters,
|};
export type Http3xxRedirectsTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: Http3xxRedirectsTable_project$ref
  |}
|};
export type Http3xxRedirectsTable_RefetchQuery = {|
  variables: Http3xxRedirectsTable_RefetchQueryVariables,
  response: Http3xxRedirectsTable_RefetchQueryResponse,
|};
*/


/*
query Http3xxRedirectsTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $codeFilters: [Int]
  $typeFilters: [String]
  $sourceUrl: TextFilters
  $redirectUrl: TextFilters
) {
  project(host: $host) {
    ...Http3xxRedirectsTable_project_3XmyUn
    id
  }
}

fragment Http3xxRedirectsTable_project_3XmyUn on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesHttp3xxRedirects(sourceUrl: $sourceUrl, redirectUrl: $redirectUrl, codeFilters: $codeFilters) {
          type
          severity
          count
        }
        countCodesHttp3xxRedirects(sourceUrl: $sourceUrl, redirectUrl: $redirectUrl, typeFilters: $typeFilters) {
          code
          count
        }
        http3xxRedirects(offset: $offset, limit: $limit, codeFilters: $codeFilters, typeFilters: $typeFilters, sourceUrl: $sourceUrl, redirectUrl: $redirectUrl) {
          count
          edges {
            node {
              ...Http3xxRedirectsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment Http3xxRedirectsRow_issue on Http3xxRedirect {
  id
  type
  severity
  code
  redirect_count
  redirect_urls
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "codeFilters",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "redirectUrl",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "codeFilters",
  "variableName": "codeFilters",
  "type": "[Int]"
},
v3 = {
  "kind": "Variable",
  "name": "redirectUrl",
  "variableName": "redirectUrl",
  "type": "TextFilters"
},
v4 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "typeFilters",
  "variableName": "typeFilters",
  "type": "[String]"
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Http3xxRedirectsTable_RefetchQuery",
  "id": null,
  "text": "query Http3xxRedirectsTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $codeFilters: [Int]\n  $typeFilters: [String]\n  $sourceUrl: TextFilters\n  $redirectUrl: TextFilters\n) {\n  project(host: $host) {\n    ...Http3xxRedirectsTable_project_3XmyUn\n    id\n  }\n}\n\nfragment Http3xxRedirectsTable_project_3XmyUn on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesHttp3xxRedirects(sourceUrl: $sourceUrl, redirectUrl: $redirectUrl, codeFilters: $codeFilters) {\n          type\n          severity\n          count\n        }\n        countCodesHttp3xxRedirects(sourceUrl: $sourceUrl, redirectUrl: $redirectUrl, typeFilters: $typeFilters) {\n          code\n          count\n        }\n        http3xxRedirects(offset: $offset, limit: $limit, codeFilters: $codeFilters, typeFilters: $typeFilters, sourceUrl: $sourceUrl, redirectUrl: $redirectUrl) {\n          count\n          edges {\n            node {\n              ...Http3xxRedirectsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Http3xxRedirectsRow_issue on Http3xxRedirect {\n  id\n  type\n  severity\n  code\n  redirect_count\n  redirect_urls\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Http3xxRedirectsTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Http3xxRedirectsTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "codeFilters",
                "variableName": "codeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "redirectUrl",
                "variableName": "redirectUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Http3xxRedirectsTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesHttp3xxRedirects",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3,
                          v4
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v5,
                          v6,
                          v7
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countCodesHttp3xxRedirects",
                        "storageKey": null,
                        "args": [
                          v3,
                          v4,
                          v8
                        ],
                        "concreteType": "CountCode",
                        "plural": true,
                        "selections": [
                          v9,
                          v7
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "http3xxRedirects",
                        "storageKey": null,
                        "args": [
                          v2,
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v3,
                          v4,
                          v8
                        ],
                        "concreteType": "Http3xxRedirectsConnection",
                        "plural": false,
                        "selections": [
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Http3xxRedirectsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Http3xxRedirect",
                                "plural": false,
                                "selections": [
                                  v10,
                                  v5,
                                  v6,
                                  v9,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "redirect_count",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "redirect_urls",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v10
                    ]
                  }
                ]
              }
            ]
          },
          v10
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2edf12a534d745ee8770adf5325b0199';
module.exports = node;
